var map = {
	"./altria.png": 559,
	"./antd.svg": 806,
	"./chobani_rewards2021.jpg": 126,
	"./chobani_rewards2021_old.jpg": 412,
	"./dunkinextras.png": 958,
	"./dyla-dev.png": 269,
	"./mondelez_togethernessgames.png": 188,
	"./skoal-rewards.png": 231,
	"./sonyrewards_theperfectpair.jpg": 134,
	"./sonyrewards_theperfectpair_old.jpg": 521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 937;